import React from "react";
import type { AppPosition, TDT } from "@src/types";
import {
  MISSING_RECORDED_COLLATERAL,
  RECORDED_COLLATERAL_INTERPRETATION,
  TRACKING_ENDED_EXPLANATION,
  isPositionTrackingEnded,
} from "@src/utils/positionStatus";

interface Props {
  metrics: TDT.BacktestMetrics | null | undefined;
  positions: AppPosition[];
  quoteCurrency: string | null;
}

export const AccountingCoverageNotice: React.FC<Props> = ({
  metrics,
  positions,
  quoteCurrency,
}) => {
  const count = positions.filter(isPositionTrackingEnded).length;
  const incomplete = metrics?.incomplete_accounting === true;
  if (!incomplete && count === 0) return null;
  const collateral = metrics?.tracking_ended_collateral_quote;
  return (
    <div className="AccountingCoverageNotice">
      {incomplete && (
        <>
          <div className="AccountingCoverageMetrics">
            Incomplete accounting: these metrics exclude{" "}
            {metrics.tracking_ended_positions_count ?? "unknown"} tracking-ended position(s).
          </div>
          <div className="AccountingCoverageCollateral">
            {collateral == null
              ? `Recorded collateral of those positions: ${MISSING_RECORDED_COLLATERAL}.`
              : `Recorded collateral of those positions: ${collateral.toFixed(4)}${quoteCurrency ? ` ${quoteCurrency}` : " in the run's quote currency"} (${RECORDED_COLLATERAL_INTERPRETATION}).`}
          </div>
        </>
      )}
      {count > 0 && (
        <div className="AccountingCoveragePositions">
          {count} tracking-ended position(s) in this list: {TRACKING_ENDED_EXPLANATION}; excluded
          from profit, win and loss totals.
        </div>
      )}
      {count > 0 && typeof metrics?.incomplete_accounting !== "boolean" && (
        <div className="AccountingCoverageUnavailable">
          These metrics do not report accounting coverage.
        </div>
      )}
    </div>
  );
};
